module.exports = __webpack_public_path__ + "static/media/Icon01.2ef7c757.png";